
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip-paper-share)"}},[_c('path',{attrs:{"d":"M19.8 14.4c-1.35 0-2.539.65-3.308 1.643l-8.124-3.125c.008-.107.032-.21.032-.318 0-.202-.032-.395-.06-.59l8.326-3.842A4.174 4.174 0 0019.8 9.6c2.316 0 4.2-1.884 4.2-4.2 0-2.316-1.884-4.2-4.2-4.2a4.205 4.205 0 00-4.2 4.2c0 .202.032.395.06.59L7.334 9.831A4.174 4.174 0 004.2 8.4 4.205 4.205 0 000 12.6c0 2.316 1.884 4.2 4.2 4.2 1.35 0 2.539-.65 3.308-1.643l8.124 3.125c-.008.107-.032.21-.032.318 0 2.316 1.884 4.2 4.2 4.2 2.316 0 4.2-1.884 4.2-4.2 0-2.316-1.884-4.2-4.2-4.2z","fill":"#838383"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip-paper-share"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    